module.exports = __webpack_public_path__ + "static/media/memvra-2.730f3a8c.png";